module.exports = __webpack_public_path__ + "img/Hodgson_Oil_Building-_PE-t-24468-001.7ed37e1a.jpg";